import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import ErrorBoundary from './components/ErrorBoundary'

// Context Providers
import { VideoProvider } from './context/VideoContext'

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token')
  return token ? children : <Navigate to="/login" replace />
}

// Root Route Component - smart redirect based on auth
const RootRedirect = () => {
  const token = localStorage.getItem('token')
  return <Navigate to={token ? "/success" : "/login"} replace />
}

// Components
import { Layout } from './components/Layout/Layout'

// Pages
import LoginPage from './pages/LoginPage'
import UserLogin from './pages/UserLogin'
import UserDashboard from './pages/UserDashboard'
import HomePage from './pages/HomePage'
import UploadPage from './pages/UploadPage'
import AdminPage from './pages/AdminPage'
import PublicVideoWatch from './pages/PublicVideoWatch'
import VideoConverter from './pages/VideoConverter'

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <div className="min-h-screen bg-netflix-black">
          <Routes>
            {/* Root Route - smart redirect based on auth status */}
            <Route path="/" element={<RootRedirect />} />

            {/* Public Routes - NO AUTH REQUIRED */}
            <Route path="/login" element={<UserLogin />} />
            <Route path="/old-login" element={<LoginPage />} />

            {/* Public Video Links - COMPLETELY ISOLATED FROM AUTH */}
            <Route path="/watch/:token" element={<PublicVideoWatch />} />

            {/* Protected Routes with VideoProvider */}
            <Route path="/success" element={
              <VideoProvider>
                <ProtectedRoute>
                  <UserDashboard />
                </ProtectedRoute>
              </VideoProvider>
            } />
            <Route path="/dashboard" element={
              <VideoProvider>
                <ProtectedRoute>
                  <Layout>
                    <HomePage />
                  </Layout>
                </ProtectedRoute>
              </VideoProvider>
            } />
            <Route path="/upload" element={
              <VideoProvider>
                <ProtectedRoute>
                  <UploadPage />
                </ProtectedRoute>
              </VideoProvider>
            } />
            <Route path="/admin" element={
              <VideoProvider>
                <AdminPage />
              </VideoProvider>
            } />

            {/* Catch all redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
            
            {/* Toast notifications */}
            <Toaster 
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#1f2937',
                  color: '#fff',
                  border: '1px solid #374151'
                },
                success: {
                  iconTheme: {
                    primary: '#10b981',
                    secondary: '#fff',
                  },
                },
                error: {
                  iconTheme: {
                    primary: '#ef4444',
                    secondary: '#fff',
                  },
                },
              }}
            />
          </div>
        </Router>
      </ErrorBoundary>
  )
}

export default App